<template>
  <div class="booking">
    <location @show-mobile-calendar="showMobileCalendar"> </location>
    <calendar-layout
      @closeDataModal="isShowMobileCalendar = false"
      :class="{ show: isShowMobileCalendar }"
    />
  </div>
</template>

<script>
import Location from './Location.vue'
import CalendarLayout from './CalendarComponent/CalendarLayout.vue'

export default {
  name: 'Booking',
  components: {CalendarLayout, Location},
  data() {
    return {
      isShowMobileCalendar: false
    }
  },
  methods: {
    showMobileCalendar() {
      this.isShowMobileCalendar = true
    }
  }
}
</script>

<style scoped>
.booking {
  width: 80%;
  display: flex;
  flex-direction: row;
  height: calc(100% - 85px);


}

@media (max-width:  1460px) {
  .booking{
    width: 75%;
  }
}
@media (max-width: 1050px) {
  .booking{
    width: 100%;
    height: 100%;

  }
}
</style>



// WEBPACK FOOTER //
// src/components/client/BookingLayout.vue